import { useTranslation } from 'react-i18next'
import { pageTitle } from '@/lib/form-styles'
import { StandardItemsTab } from './SelectionDataPage'

/** Einzelseite „Betriebsstätten" (Inhalt einer Auswahlliste). */
export default function BetriebsstaettenPage() {
  const { t } = useTranslation()
  return (
    <div className="space-y-4 p-4 sm:p-6">
      <h1 className={pageTitle}>Betriebsstätten</h1>
      <StandardItemsTab t={t} category="betriebsstaette" />
    </div>
  )
}
